import { inject, Injectable } from '@angular/core';
import { Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ValidationMessageResolver } from '@ngx-strakit/validation';

@Injectable()
export class SkMinValidationMessageResolver implements ValidationMessageResolver<{ min: unknown }> {
  private readonly translate = inject(TranslateService);
  readonly errorCode = Validators.min.name;

  getMessage(error?: { min: unknown }): string {
    return this.translate.instant('label.validation.min', { value: error?.min });
  }
}
